import { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useToast } from "../use-toast";
import { useSmartNavigation } from "../useSmartNavigation";
import { useVoiceRecognition } from "../useVoiceRecognition";
import { VOICE_RECOGNITION_CONFIG } from "../../config/voiceRecognition.config";
import { useEditorActions } from "../../components/editor/EditorStateProvider";

export function useWorkspaceDependencies() {
  const { user, signOut } = useAuth();
  const { toast } = useToast();
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [signOutDialogOpen, setSignOutDialogOpen] = useState(false);
  const [betaKeyModalOpen, setBetaKeyModalOpen] = useState(false);

  const { closeEditor, setCurrentPoll } = useEditorActions();

  // Hook de navigation intelligente avec reset du chat
  const { smartNavigate } = useSmartNavigation({
    debug: process.env.NODE_ENV === "development",
    onResetStrategy: (strategy) => {
      console.log("🔄 Reset strategy applied:", strategy);

      // Si reset complet, nettoyer aussi l'éditeur
      if (strategy.resetType === "full") {
        closeEditor();
        setCurrentPoll(null);
      }

      // Si reset contextuel, conserver l'éditeur mais réinitialiser le poll courant
      if (strategy.resetType === "context-only") {
        setCurrentPoll(null);
      }
    },
  });

  // Hook reconnaissance vocale UNIQUE pour toute l'application
  const voiceRecognition = useVoiceRecognition({
    lang: VOICE_RECOGNITION_CONFIG.lang,
    interimResults: VOICE_RECOGNITION_CONFIG.interimResults,
    continuous: VOICE_RECOGNITION_CONFIG.continuous,
    onTranscriptChange: () => {
      // Ne rien faire ici, on utilisera finalTranscript directement
    },
    onError: (error) => {
      toast({
        title: "Erreur microphone",
        description: error,
        variant: "destructive",
      });
    },
  });

  return {
    user,
    signOut,
    toast,
    smartNavigate,
    voiceRecognition,
    modals: {
      auth: { open: authModalOpen, setOpen: setAuthModalOpen },
      signOut: { open: signOutDialogOpen, setOpen: setSignOutDialogOpen },
      betaKey: { open: betaKeyModalOpen, setOpen: setBetaKeyModalOpen },
    },
  };
}
